var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.07,
    d: "M57 53h28l3.5 3.5L92 60v37H57V53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4 96.25l-35.75.15V53.65h23.4c1 0 1.95.35 2.65 1l7.35 6.95.05.05c.6.6.95 1.35.95 2.1v24.7a1.85 1.85 0 1 0 3.7 0v-24.7c0-1.85-.75-3.55-2.15-4.8l-.05-.05-7.4-6.95a7.54 7.54 0 0 0-5.1-1.95h-23.4c-2 0-3.65 1.55-3.65 3.5v42.95a3.6 3.6 0 0 0 3.65 3.5H93.4c1 0 1.85-.8 1.85-1.85a1.88 1.88 0 0 0-1.85-1.85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1 64.55h-12a1.85 1.85 0 1 0 0 3.7h12a1.85 1.85 0 1 0 0-3.7zM84.05 64.55h-2.5a1.85 1.85 0 1 0 0 3.7h2.5a1.85 1.85 0 1 0 0-3.7zM75.1 71.85h-12c-1 0-1.85.8-1.85 1.85s.8 1.85 1.85 1.85h12a1.85 1.85 0 1 0 0-3.7zM75.1 79.2h-12a1.85 1.85 0 1 0 0 3.7h12a1.85 1.85 0 1 0 0-3.7zM84.05 71.85h-2.5c-1 0-1.85.8-1.85 1.85s.8 1.85 1.85 1.85h2.5a1.85 1.85 0 1 0 0-3.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTask);
export default __webpack_public_path__ + "static/media/empty-task.401b6827.svg";
export { ForwardRef as ReactComponent };